var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 464H333.999L289.125 100.75C288.375 93.375 285.125 86.5 279.875 81.25L203.25 4.75C200.375 1.625 196.25 0 192 0C187.875 0 183.75 1.5 180.75 4.75L104.125 81.25C98.875 86.5 95.625 93.375 94.875 100.75L49.999 464H24C10.745 464 0 474.745 0 488V488C0 501.255 10.745 512 24 512H360C373.255 512 384 501.255 384 488V488C384 474.745 373.255 464 360 464ZM98.375 464L141.875 111.375L192 61.25L242.125 111.375L285.625 464H98.375ZM216 272H168C154.8 272 144 282.8 144 296V296C144 309.2 154.8 320 168 320H216C229.2 320 240 309.2 240 296V296C240 282.8 229.2 272 216 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonument);
export default __webpack_public_path__ + "static/media/monument.1cbd06ec2c194db5b271f231cff38e12.svg";
export { ForwardRef as ReactComponent };